import { useContext } from 'react';

import { Box, Label, LabeledControl, Radio, Text } from '@zillow/constellation-10';

import { FreemiumContext } from '../../../../context';

import { RoutingSelectors } from '../../../../../../selectors';
import { useSelector } from '../../../../../../selectors/useSelector';

import { useGetPremiumOverview } from '../../../../../../hooks/queries/freemium';

import actions from '../../../../../../components/Freemium/actions';

import { DEFAULT_FILTER_VALUE } from '../../../../../../constants/PremiumConstants';
import type { FilterCriteria } from '../../../../interfaces';

const Filters = () => {
  const {
    freemiumState,
    freemiumState: {
      filters: { beds, filterType, propertyType },
    },
    // @ts-expect-error
    freemiumReducerDispatch,
  } = useContext(FreemiumContext);

  const listingId = useSelector((state) => RoutingSelectors.makeListingId(state));

  const { data: premiumOverview } = useGetPremiumOverview(
    {
      listingId,
      filterType,
      beds,
      propertyType,
    },
    {
      keepPreviousData: true,
    },
  );

  const myPropertyDetailsFilters: FilterCriteria = {
    filterType: 'zip',
    propertyType: premiumOverview?.propertyType?.code,
    beds: premiumOverview?.beds,
  };

  const allPropertiesFilters: FilterCriteria = {
    filterType: 'cityState',
    propertyType: DEFAULT_FILTER_VALUE,
    beds: DEFAULT_FILTER_VALUE,
  };

  if (!premiumOverview) {
    return null;
  }

  const handleFilterChange = (filters: FilterCriteria) => {
    actions.updatePremiumFilters({
      reducerDispatch: freemiumReducerDispatch,
      filters: {
        filterType: filters.filterType,
        ...(filters.beds != null && { beds: String(filters.beds) }),
        ...(filters.propertyType != null && { propertyType: String(filters.propertyType) }),
      },
    });
  };

  return (
    <Box
      css={{
        display: 'flex',
        alignItems: { base: 'flex-start', xl: 'center' },
        flexDirection: { base: 'column', xl: 'row' },
        justifyContent: 'space-between',
        marginBottom: '600',
        paddingLeft: { base: '200', lg: 0 },
      }}
    >
      <LabeledControl
        css={{ marginRight: '400' }}
        key="myPropertyDetails"
        label={
          <Label>
            <Text textStyle="body-sm" asChild>
              <span>
                {typeof premiumOverview?.beds !== 'undefined' ? `${premiumOverview?.beds} bedroom` : 'All'}{' '}
                {premiumOverview?.propertyType?.display.toLowerCase()}s in {premiumOverview?.zip}
              </span>
            </Text>
          </Label>
        }
        control={
          <Radio
            name="myPropertyDetails"
            onChange={() => handleFilterChange(myPropertyDetailsFilters)}
            checked={freemiumState?.filters?.beds === premiumOverview?.beds}
          />
        }
      />
      <LabeledControl
        key="all"
        label={
          <Label>
            <Text textStyle="body-sm" asChild>
              <span>All {premiumOverview?.city} rentals</span>
            </Text>
          </Label>
        }
        control={
          <Radio
            name="all"
            onChange={() => handleFilterChange(allPropertiesFilters)}
            checked={freemiumState?.filters?.beds === 'all'}
          />
        }
      />
    </Box>
  );
};

export default Filters;
